import React, { useEffect, useState } from 'react';
import { useThemeColors } from '../hooks/useThemeColors';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  clearRegisterState,
  getRegisterUser,
  getUserRegisteration,
} from '../redux/auth/authSlice';
import { toast } from 'react-toastify';
import { FaTimes } from 'react-icons/fa';

function Registration({ darkMode, onClose, isPopup, onSwitchToLogin }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Hook se central colors nikal rahe hain
  const { themeBg, textColor, cardBg, borderColor, isDark, subTextColor } =
    useThemeColors(darkMode);

  const registerResponse = useSelector(getUserRegisteration);

  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    emailAddress: '',
    mobileNumber: '',
    password: '',
  });

  useEffect(() => {
    if (registerResponse && registerResponse.canLogin === true) {
      toast.success('Registration Successful!');
      const timer = setTimeout(() => {
        dispatch(clearRegisterState());
        if (isPopup) {
          onSwitchToLogin(); // Registration ke baad Login popup par le jayein
        } else {
          navigate('/login');
        }
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [registerResponse, dispatch, navigate, isPopup, onSwitchToLogin]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors && errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.emailAddress || !formData.password) {
      toast.warn('Please fill all required fields');
      return;
    }
    const payload = {
      name: formData.name,
      surname: formData.name,
      userName: formData.emailAddress,
      emailAddress: formData.emailAddress,
      mobileNumber: formData.mobileNumber,
      password: formData.password,
      captchaResponse: 'string',
    };
    dispatch(getRegisterUser(payload));
  };

  const inputStyle = {
    backgroundColor: isDark ? 'rgba(255,255,255,0.05)' : '#fff',
    color: textColor,
    border: `1px solid ${borderColor}`,
    borderRadius: '12px',
    padding: '12px 15px',
    fontSize: '16px',
  };

  return (
    <div
      className="registration-master-wrapper d-flex justify-content-center align-items-end align-items-md-center"
      style={{
        zIndex: 1200,
        backgroundColor: isPopup ? 'rgba(0,0,0,0.5)' : themeBg,
      }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        className="registration-card-container rounded shadow-lg position-relative border-0"
        style={{
          width: '100%',
          maxWidth: '500px', // Registration ke liye thori zyada width achi lagti hai
          backgroundColor: cardBg,
          color: textColor,
          maxHeight: '90vh',
          overflowY: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        {isPopup && (
          <button
            onClick={onClose}
            className="btn p-2 border-0 position-absolute top-0 end-0 mt-3 me-3"
            style={{ color: subTextColor, zIndex: 10 }}
          >
            <FaTimes size={20} />
          </button>
        )}

        <div className="p-4 py-md-5">
          <div className="text-center mb-4">
            <h2
              className="fw-bold mb-1"
              style={{ letterSpacing: '-1.5px', fontSize: '2rem' }}
            >
              Create Account
            </h2>
            <p className="small px-3" style={{ color: subTextColor }}>
              Join us today! Please fill in your information to get started.
            </p>
          </div>

          <form onSubmit={handleSubmit} noValidate className="w-100 mx-auto">
            <div className="row g-3">
              {/* Name Field */}
              <div className="col-12">
                <label
                  className="form-label fw-bold small text-uppercase mb-1"
                  style={{ fontSize: '11px', letterSpacing: '0.5px' }}
                >
                  Full Name
                </label>
                <input
                  type="text"
                  name="name"
                  style={inputStyle}
                  className="form-control shadow-none"
                  value={formData.name || ''}
                  onChange={handleChange}
                  placeholder="John Doe"
                  required
                />
              </div>

              {/* Email Field */}
              <div className="col-12">
                <label
                  className="form-label fw-bold small text-uppercase mb-1"
                  style={{ fontSize: '11px', letterSpacing: '0.5px' }}
                >
                  Email Address
                </label>
                <input
                  type="email"
                  name="emailAddress"
                  style={inputStyle}
                  className="form-control shadow-none"
                  placeholder="user@example.com"
                  value={formData.emailAddress || ''}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Mobile Field */}
              <div className="col-12">
                <label
                  className="form-label fw-bold small text-uppercase mb-1"
                  style={{ fontSize: '11px', letterSpacing: '0.5px' }}
                >
                  Mobile Number
                </label>
                <input
                  type="text"
                  name="mobileNumber"
                  style={inputStyle}
                  className="form-control shadow-none"
                  value={formData.mobileNumber || ''}
                  onChange={handleChange}
                  placeholder="e.g. 03XXXXXXXXX"
                />
              </div>

              {/* Password Field */}
              <div className="col-12 mb-2">
                <label
                  className="form-label fw-bold small text-uppercase mb-1"
                  style={{ fontSize: '11px', letterSpacing: '0.5px' }}
                >
                  Password
                </label>
                <input
                  type="password"
                  name="password"
                  style={inputStyle}
                  className="form-control shadow-none"
                  value={formData.password || ''}
                  onChange={handleChange}
                  placeholder="••••••••"
                  required
                />
              </div>
            </div>

            <div className="d-grid gap-3 mt-4">
              <button
                type="submit"
                className="btn btn-danger py-3 fw-bold shadow-sm rounded-3 text-uppercase"
                style={{ fontSize: '14px', letterSpacing: '1px' }}
              >
                Register Now
              </button>

              <button
                type="button"
                className="btn btn-link text-decoration-none fw-bold shadow-none"
                onClick={() =>
                  isPopup ? onSwitchToLogin() : navigate('/login')
                }
                style={{ color: isDark ? '#fff' : '#dc3545', fontSize: '13px' }}
              >
                Already have an account? Login here
              </button>
            </div>
          </form>

          <div
            className="text-center mt-5 opacity-50"
            style={{ fontSize: '10px' }}
          >
            By creating an account, you agree to our <br />
            <b>Privacy Policy & Terms</b>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Registration;